<script setup>
import { defineProps, computed, reactive, ref, watch } from 'vue';
import VueApexCharts from "vue3-apexcharts";

const chartLabelColor = '#fff';
const chartBarColor = '#4CAF50';

const props = defineProps({
    data: {
        type: Array,
        required: true,
    },
    chartTitle: {
        type: String,
        default: null,
    },
    xAxisTitle: {
        type: String,
        default: null,
    },
    yAxisTitle: {
        type: String,
        default: null,
    },
});


let chartOptions = ref({
    chart: {
        type: "bar",
        width: "100%",
        height: "auto",
        foreColor: '#898989',
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false
        },
    },
    colors: [chartBarColor],
    stroke: {
        width: 0,
    },
    plotOptions: {
        bar: {
            dataLabels: {
                position: 'top'
            }
        }
    },
    dataLabels: {
        enabled: false,
        offsetY: -20,
        formatter: function (val) {
            return val.toFixed(1) + "%";
        },
        style: {
            fontSize: '10px',
        }
    },
    title: {
        text: props.chartTitle || '',
        align: 'center',
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: chartLabelColor
        },
    },
    grid: {
        enabled: false,
        yaxis: {
            lines: {
                show: false
            }
        },
        xaxis: {
            lines: {
                show: false
            }
        }
    },
    xaxis: {
        axisBorder: {
            color: chartLabelColor,
        },
        title: {
            text: props.xAxisTitle || '',
            style: {
                color: chartLabelColor
            }
        }
    },
    yaxis: {
        min: 0,
        axisBorder: {
            color: chartLabelColor,
        },
        title: {
            text: props.yAxisTitle || '',
            style: {
                color: chartLabelColor,
            },
        },
        tooltip: {
            enabled: true,
        },
        labels: {
            formatter: function (val) {
                return val.toFixed(0) + "%";
            }
        }
    },
    fill: {
        opacity: 1,
    },
    tooltip: {
        enabled: true,
        enabledOnSeries: false,
        theme: "dark",
        opacity: 1,
        x: {
            formatter: (val) => {
                return 'Hour: ' + val;
            },
            title: 'x'
        },
        onDatasetHover: {
          highlightDataSeries: false,
      },
    }
});

const dataParsed = computed(() => {
    return props.data.map((item) => {
        return {
            x: item['hour'],
            y: item['Percent']
        }
    });
});

const series = reactive([
    {
        data: dataParsed || [],
        name: 'Percent'
    }
])

watch(() => props.data, (newValue) => {
    series[0].data = dataParsed;
});
</script>

<template>
    <div class="hoursSplit">
        <VueApexCharts type="bar" :options="chartOptions" :series="series" height="450" />
    </div>
</template>